export default __webpack_public_path__ + "static/media/OpenSans-regular.ce19db64.ttf";